import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducer';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { TestEmailTemplate } from '../store/templates.actions';

@Component({
    selector: 'app-test-template-dialog',
    templateUrl: './test-template-dialog.component.html',
    styleUrls: ['./test-template-dialog.component.scss']

})
export class TestTemplateDialog {
    form;
    isEdit;
    pillar;
    constructor(
        private store: Store<AppState>,
        private fb: FormBuilder,
        private matDialogRef: MatDialogRef<TestTemplateDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.matDialogRef.disableClose = true;
        this.form = this.fb.group({
            email: ['', Validators.compose([
                Validators.required,
                Validators.email
            ])]
        });

    }

    testTemplate() {
        this.store.dispatch(new TestEmailTemplate(this.data.id, this.form.value))
        this.matDialogRef.close();
    }

    cancel() {
        this.matDialogRef.close();
    }
}
